import React, { FC } from 'react';

import { SectionOneColumn } from '@/components/organisms/SectionOneColumn/render';

import block from './block.json';

/**
 * COMPONENT
 */
export const SectionButtonsAnchor: FC<SectionOneColumnProps> & BlockConfigs = (
	props
) => {
	return <SectionOneColumn {...props} />;
};

SectionButtonsAnchor.slug = block.slug;
SectionButtonsAnchor.title = block.title;
